export const PATIENT_AUTH_ERROR_CODES = Object.freeze({
  required: "PATIENT_AUTH_REQUIRED",
});
